/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'

export default class FeeType extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    const options = [
      { key: 1, text: 'Fixed', value: 'FIXED' },
      // { key: 2, text: 'Percentage', value: 'PERCENTAGE' },
    ]

    return (
      <Form.Select
        required
        fluid
        label="Type"
        options={options}
        placeholder="Fixed/Percentage"
        onChange={(e, data) => onChange('type', data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/feeTypeField.js